/**
 * Module-level cache for the model registry.
 * Prevents TrainedModelConfig and ScorePredictConfig from hammering
 * /flows/ops/models on every node selection click.
 *
 * The cache lives for the lifetime of the browser tab session.
 * Call invalidateModelRegistryCache() after training a new model.
 */
import { apiGet } from '@/api';

export type RegistryModel = { id: string; name: string; model_type: string; feature_columns?: string[] };

let _cache: RegistryModel[] | null = null;
let _inflight: Promise<RegistryModel[]> | null = null;

export async function fetchModelRegistry(): Promise<RegistryModel[]> {
    if (_cache !== null) return _cache;
    if (_inflight) return _inflight;

    _inflight = apiGet('/flows/ops/models')
        .then((list: any) => {
            _cache = Array.isArray(list) ? list : [];
            _inflight = null;
            return _cache!;
        })
        .catch(() => {
            _inflight = null; // allow retry on next selection
            return [] as RegistryModel[];
        });

    return _inflight;
}

/** Call this after a Train Model node completes so the next selection sees the new model. */
export function invalidateModelRegistryCache(): void {
    _cache = null;
    _inflight = null;
}
